export default __webpack_public_path__ + "static/media/Inbox.22d6f77b.svg";